import { useState } from "react";

import {
  ReminderClockIcon,
  HotIcon,
  WarmIcon,
  ColdIcon,
} from "../../lead-inventory/icons";

const DetailsSidebarCard = ({
  contactData,
  reminderData,
  accountOwnership,
}) => {
  const [showAccIDCopied, setShowAccIDCopied] = useState(false);
  const [showNameCopied, setShowNameCopied] = useState(false);
  const [showEmailCopied, setShowEmailCopied] = useState(false);
  const [showPhoneCopied, setShowPhoneCopied] = useState(false);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4 border border-[#64748B] rounded-lg p-4 bg-white">
        <h1 className="font-bold text-xl">Account Ownership</h1>
        <div className="flex flex-col gap-2">
          <div className="py-2 flex justify-between items-center">
            <div>
              <h3 className="font-bold text-l">Account ID</h3>
              <span>{accountOwnership?.mm_acc_id || 'N/A'} </span>
            </div>
            <div className="relative">
              <button
                onClick={() => {
                  navigator.clipboard.writeText(
                    accountOwnership?.mm_acc_id || 'N/A'
                  );
                  setShowAccIDCopied(true);
                  setTimeout(() => setShowAccIDCopied(false), 1000);
                }}
                className="hover:text-gray-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.5 8.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v8.25A2.25 2.25 0 0 0 6 16.5h2.25m8.25-8.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-7.5A2.25 2.25 0 0 1 8.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 0 0-2.25 2.25v6"
                  />
                </svg>
              </button>
              {showAccIDCopied && (
                <div className="absolute -top-8 right-0 bg-gray-800 text-white px-2 py-1 rounded text-sm">
                  Copied!
                </div>
              )}
            </div>
          </div>
          <div className="py-2 flex justify-between items-center relative">
            <div>
              <h3 className="font-bold text-l">Hunter</h3>
              <span>{accountOwnership?.username || "N/A"}</span>
            </div>
          </div>
          <div className="py-2 flex justify-between items-center relative">
            <div>
              <h3 className="font-bold text-l">Average Frequency</h3>
              <a>{accountOwnership?.avg_frequency || "N/A"}</a>
            </div>
          </div>
          <div className="py-2 flex justify-between items-center relative">
            <div>
              <h3 className="font-bold text-l">Relationship Strength</h3>
              <span>
                {accountOwnership?.interest_level === 1 && (
                  <img
                    src={ColdIcon}
                    alt="Cold"
                    className="w-6 h-6 inline-block gap-1"
                  />
                )}
                {accountOwnership?.interest_level === 2 && (
                  <img
                    src={WarmIcon}
                    alt="Warm"
                    className="w-6 h-6 inline-block gap-1"
                  />
                )}
                {accountOwnership?.interest_level === 3 && (
                  <img
                    src={HotIcon}
                    alt="Hot"
                    className="w-6 h-6 inline-block gap-1"
                  />
                )}
                {(!accountOwnership?.interest_level ||
                  ![1, 2, 3].includes(accountOwnership?.interest_level)) &&
                  "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-4 border border-[#64748B] rounded-lg p-4 bg-white">
        <h1 className="font-bold text-xl">PIC Details</h1>
        <div className="flex flex-col gap-2">
          <div className="py-2 flex justify-between items-center">
            <div>
              <h3 className="font-bold text-l">Name</h3>
              <span>
                {contactData?.name ? `${contactData?.salutation ?? ''} ${contactData?.name}`.trim() : 'N/A'}
              </span>
            </div>
            <div className="relative">
              <button
                onClick={() => {
                  navigator.clipboard.writeText(
                    `${contactData?.name ? `${contactData?.salutation ?? ''} ${contactData?.name}`.trim() : 'N/A'}`
                  );
                  setShowNameCopied(true);
                  setTimeout(() => setShowNameCopied(false), 1000);
                }}
                className="hover:text-gray-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.5 8.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v8.25A2.25 2.25 0 0 0 6 16.5h2.25m8.25-8.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-7.5A2.25 2.25 0 0 1 8.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 0 0-2.25 2.25v6"
                  />
                </svg>
              </button>
              {showNameCopied && (
                <div className="absolute -top-8 right-0 bg-gray-800 text-white px-2 py-1 rounded text-sm">
                  Copied!
                </div>
              )}
            </div>
          </div>
          <div className="py-2 flex justify-between items-center relattive">
            <div>
              <h3 className="font-bold text-l">Contact Number</h3>
              <span>
                {contactData?.mobile_no ? `${contactData?.mobile_no}` : "N/A"}
              </span>
            </div>
            <div className="relative">
              <button
                onClick={() => {
                  navigator.clipboard.writeText(`${contactData?.mobile_no}`);
                  setShowPhoneCopied(true);
                  setTimeout(() => setShowPhoneCopied(false), 1000);
                }}
                className="hover:text-gray-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.5 8.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v8.25A2.25 2.25 0 0 0 6 16.5h2.25m8.25-8.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-7.5A2.25 2.25 0 0 1 8.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 0 0-2.25 2.25v6"
                  />
                </svg>
              </button>
              {showPhoneCopied && (
                <div className="absolute -top-8 right-0 bg-gray-800 text-white px-2 py-1 rounded text-sm">
                  Copied!
                </div>
              )}
            </div>
          </div>
          <div className="py-2 flex justify-between items-center relative">
            <div>
              <h3 className="font-bold text-l">Email Address</h3>
              <a>{contactData?.email ? `${contactData.email}` : "N/A"}</a>
            </div>
            <div className="relative">
              <button
                onClick={() => {
                  navigator.clipboard.writeText(`${contactData?.email}`);
                  setShowEmailCopied(true);
                  setTimeout(() => setShowEmailCopied(false), 1000);
                }}
                className="hover:text-gray-600"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.5 8.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v8.25A2.25 2.25 0 0 0 6 16.5h2.25m8.25-8.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-7.5A2.25 2.25 0 0 1 8.25 18v-1.5m8.25-8.25h-6a2.25 2.25 0 0 0-2.25 2.25v6"
                  />
                </svg>
              </button>
              {showEmailCopied && (
                <div className="absolute -top-8 right-0 bg-gray-800 text-white px-2 py-1 rounded text-sm">
                  Copied!
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-4 border border-[#64748B] rounded-lg p-4 bg-white">
        <div className="flex flex-row justify-between items-center">
          <h1 className="font-bold text-xl">Upcoming Reminder</h1>
          <span className="flex w-auto h-auto px-4 py-2 gap-2 top-5 rounded-full border font-bold bg-[#FEFAD8] border-[#FEFAD8] text-[#212121] text-sm items-center">
            <img
              src={ReminderClockIcon}
              alt="Clock"
              className="w-4 h-4 inline-block gap-1"
            />
            {reminderData?.reminder_at}
          </span>
        </div>
        <div className="p-2 flex flex-col rounded-lg bg-[#F2F4F7] border-[#F2F4F7]">
          <h2 className="font-bold">{reminderData?.reminder_title}</h2>
          <a>{reminderData?.reminder_details}</a>
        </div>
      </div>
    </div>
  );
};

export default DetailsSidebarCard;
